import requests from "./httpService";

const EmployeeService = {
     getAllEmployee: async () =>{
        return requests.get("/employee/all");
     },
     getEmployeeById: async (id, body) =>{
        return requests.get(`/employee/${id}`, body);
     },
     UpdateEmployeeById: async (id, body) =>{
        return requests.put(`/employee/${id}`, body);
     },
     addEmployee: async (body) =>{
        return requests.post("/employee/add", body);
     },
     deleteEmployeeById: async (id) =>{
        return requests.delete(`/employee/${id}`);
     }
}

export default EmployeeService;